/**
 * * Модель запроса на проверку наличия задачи weeek на pm
 */
export class WeeekTaskCheckExistsRequestModel {
  /**
   * * Номер задачи
   */
  WeeekTaskId!: number;
  /**
   * * Номер проекта
   */
  ProjectId!: number;
  constructor(obj?: Partial<WeeekTaskCheckExistsRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
